import { render, staticRenderFns } from "./channel-ads.vue?vue&type=template&id=1dc70577&scoped=true&lang=pug"
import script from "./channel-ads.vue?vue&type=script&lang=js"
export * from "./channel-ads.vue?vue&type=script&lang=js"
import style0 from "./channel-ads.vue?vue&type=style&index=0&id=1dc70577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc70577",
  null
  
)

export default component.exports